import * as yup from 'yup';

export const validURL = (str: string) => {
  return yup.string().url().isValidSync(str);
};

/**
 * Validates an ID parameter to prevent client-side request forgery attacks
 * @param id - The ID to validate
 * @returns true if the ID is valid, false otherwise
 */
export const isValidId = (id: any): boolean => {
  return id && typeof id === 'string' && /^\d+$/.test(id);
};

/**
 * Validates an ID parameter and throws an error if invalid
 * @param id - The ID to validate
 * @param paramName - The name of the parameter for error message
 * @throws Error if the ID is invalid
 */
export const validateId = (id: any, paramName: string = 'ID'): void => {
  if (!isValidId(id)) {
    throw new Error(`Invalid ${paramName}: must be a non-empty numeric string`);
  }
};

/**
 * Safely validates and returns an ID, or returns null if invalid
 * @param id - The ID to validate
 * @returns The validated ID or null if invalid
 */
export const safeValidateId = (id: any): string | null => {
  return isValidId(id) ? id : null;
};